import { render, staticRenderFns } from "./AsStampStatusListItem.vue?vue&type=template&id=d20a5c52"
import script from "./AsStampStatusListItem.vue?vue&type=script&lang=js"
export * from "./AsStampStatusListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports